/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Portal_View_WeekInputs */

const en_portal_view_week = /** @type {(inputs: Portal_View_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`W${i?.n}`)
};

const pl_portal_view_week = /** @type {(inputs: Portal_View_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`T${i?.n}`)
};

/**
* | output |
* | --- |
* | "W{n}" |
*
* @param {Portal_View_WeekInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_view_week = /** @type {((inputs: Portal_View_WeekInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_View_WeekInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_view_week(inputs)
	return en_portal_view_week(inputs)
});